module.exports = __webpack_public_path__ + "images/fa-ft2024-bg-footer-mobile.webp";